/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import stylesheet
 */
import '../scss/front.scss';

/**
 * Import modules / classes
 */
import PageScroll from "./modules/PageScroll";
import Tabs from "./modules/Tabs";
import Accordion from "./modules/Accordion";

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener("DOMContentLoaded", () => {
    const myPageScroll = new PageScroll();
    const myTabs = new Tabs("jsTabs");

    const infoAccordions = [...document.querySelectorAll(".jsAccordion")];
    if (infoAccordions.length) {
        infoAccordions.forEach((infoAccordion) => new Accordion(infoAccordion));
    }
});
